module.exports = __webpack_public_path__ + "images/category_lp/camera/new/store_images/5_c166eb1ad4e68000c3abfa544ba230eb.png";